module.exports = __webpack_public_path__ + "img/5a487865eb83e127a152fb22c6f779c_03.59f7ff4e.gif";